/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AmbulanzResponse,
  CreateAmbulanzRequest,
  ProblemDetails,
  UpdateAmbulanzRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    AmbulanzResponseFromJSON,
    AmbulanzResponseToJSON,
    CreateAmbulanzRequestFromJSON,
    CreateAmbulanzRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateAmbulanzRequestFromJSON,
    UpdateAmbulanzRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface ClaimAmbulanzRequest {
    ambulanzId: string;
}

export interface CompleteAmbulanzRequest {
    ambulanzId: string;
}

export interface CreateAmbulanzOperationRequest {
    createAmbulanzRequest: CreateAmbulanzRequest;
}

export interface GetAllAmbulanzesRequest {
    includeCompleted?: boolean;
}

export interface GetAmbulanzByIdRequest {
    ambulanzId: string;
}

export interface ReturnAmbulanzRequest {
    ambulanzId: string;
}

export interface UpdateAmbulanzOperationRequest {
    ambulanzId: string;
    updateAmbulanzRequest: UpdateAmbulanzRequest;
}

/**
 * AmbulanzesApi - interface
 * 
 * @export
 * @interface AmbulanzesApiInterface
 */
export interface AmbulanzesApiInterface {
    /**
     * 
     * @param {string} ambulanzId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmbulanzesApiInterface
     */
    claimAmbulanzRaw(requestParameters: ClaimAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>>;

    /**
     */
    claimAmbulanz(requestParameters: ClaimAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse>;

    /**
     * 
     * @param {string} ambulanzId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmbulanzesApiInterface
     */
    completeAmbulanzRaw(requestParameters: CompleteAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>>;

    /**
     */
    completeAmbulanz(requestParameters: CompleteAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse>;

    /**
     * 
     * @param {CreateAmbulanzRequest} createAmbulanzRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmbulanzesApiInterface
     */
    createAmbulanzRaw(requestParameters: CreateAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>>;

    /**
     */
    createAmbulanz(requestParameters: CreateAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse>;

    /**
     * 
     * @param {boolean} [includeCompleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmbulanzesApiInterface
     */
    getAllAmbulanzesRaw(requestParameters: GetAllAmbulanzesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AmbulanzResponse>>>;

    /**
     */
    getAllAmbulanzes(requestParameters: GetAllAmbulanzesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AmbulanzResponse>>;

    /**
     * 
     * @param {string} ambulanzId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmbulanzesApiInterface
     */
    getAmbulanzByIdRaw(requestParameters: GetAmbulanzByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>>;

    /**
     */
    getAmbulanzById(requestParameters: GetAmbulanzByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse>;

    /**
     * 
     * @param {string} ambulanzId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmbulanzesApiInterface
     */
    returnAmbulanzRaw(requestParameters: ReturnAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>>;

    /**
     */
    returnAmbulanz(requestParameters: ReturnAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse>;

    /**
     * 
     * @param {string} ambulanzId 
     * @param {UpdateAmbulanzRequest} updateAmbulanzRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmbulanzesApiInterface
     */
    updateAmbulanzRaw(requestParameters: UpdateAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>>;

    /**
     */
    updateAmbulanz(requestParameters: UpdateAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse>;

}

/**
 * 
 */
export class AmbulanzesApi extends runtime.BaseAPI implements AmbulanzesApiInterface {

    /**
     */
    async claimAmbulanzRaw(requestParameters: ClaimAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>> {
        if (requestParameters['ambulanzId'] == null) {
            throw new runtime.RequiredError(
                'ambulanzId',
                'Required parameter "ambulanzId" was null or undefined when calling claimAmbulanz().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ambulanzes/{ambulanzId}/claim`;
        urlPath = urlPath.replace(`{${"ambulanzId"}}`, encodeURIComponent(String(requestParameters['ambulanzId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AmbulanzResponseFromJSON(jsonValue));
    }

    /**
     */
    async claimAmbulanz(requestParameters: ClaimAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse> {
        const response = await this.claimAmbulanzRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async completeAmbulanzRaw(requestParameters: CompleteAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>> {
        if (requestParameters['ambulanzId'] == null) {
            throw new runtime.RequiredError(
                'ambulanzId',
                'Required parameter "ambulanzId" was null or undefined when calling completeAmbulanz().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ambulanzes/{ambulanzId}/complete`;
        urlPath = urlPath.replace(`{${"ambulanzId"}}`, encodeURIComponent(String(requestParameters['ambulanzId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AmbulanzResponseFromJSON(jsonValue));
    }

    /**
     */
    async completeAmbulanz(requestParameters: CompleteAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse> {
        const response = await this.completeAmbulanzRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createAmbulanzRaw(requestParameters: CreateAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>> {
        if (requestParameters['createAmbulanzRequest'] == null) {
            throw new runtime.RequiredError(
                'createAmbulanzRequest',
                'Required parameter "createAmbulanzRequest" was null or undefined when calling createAmbulanz().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/ambulanzes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAmbulanzRequestToJSON(requestParameters['createAmbulanzRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AmbulanzResponseFromJSON(jsonValue));
    }

    /**
     */
    async createAmbulanz(requestParameters: CreateAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse> {
        const response = await this.createAmbulanzRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAmbulanzesRaw(requestParameters: GetAllAmbulanzesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AmbulanzResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['includeCompleted'] != null) {
            queryParameters['includeCompleted'] = requestParameters['includeCompleted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ambulanzes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AmbulanzResponseFromJSON));
    }

    /**
     */
    async getAllAmbulanzes(requestParameters: GetAllAmbulanzesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AmbulanzResponse>> {
        const response = await this.getAllAmbulanzesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAmbulanzByIdRaw(requestParameters: GetAmbulanzByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>> {
        if (requestParameters['ambulanzId'] == null) {
            throw new runtime.RequiredError(
                'ambulanzId',
                'Required parameter "ambulanzId" was null or undefined when calling getAmbulanzById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ambulanzes/{ambulanzId}`;
        urlPath = urlPath.replace(`{${"ambulanzId"}}`, encodeURIComponent(String(requestParameters['ambulanzId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AmbulanzResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAmbulanzById(requestParameters: GetAmbulanzByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse> {
        const response = await this.getAmbulanzByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async returnAmbulanzRaw(requestParameters: ReturnAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>> {
        if (requestParameters['ambulanzId'] == null) {
            throw new runtime.RequiredError(
                'ambulanzId',
                'Required parameter "ambulanzId" was null or undefined when calling returnAmbulanz().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ambulanzes/{ambulanzId}/return`;
        urlPath = urlPath.replace(`{${"ambulanzId"}}`, encodeURIComponent(String(requestParameters['ambulanzId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AmbulanzResponseFromJSON(jsonValue));
    }

    /**
     */
    async returnAmbulanz(requestParameters: ReturnAmbulanzRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse> {
        const response = await this.returnAmbulanzRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAmbulanzRaw(requestParameters: UpdateAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmbulanzResponse>> {
        if (requestParameters['ambulanzId'] == null) {
            throw new runtime.RequiredError(
                'ambulanzId',
                'Required parameter "ambulanzId" was null or undefined when calling updateAmbulanz().'
            );
        }

        if (requestParameters['updateAmbulanzRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAmbulanzRequest',
                'Required parameter "updateAmbulanzRequest" was null or undefined when calling updateAmbulanz().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/ambulanzes/{ambulanzId}`;
        urlPath = urlPath.replace(`{${"ambulanzId"}}`, encodeURIComponent(String(requestParameters['ambulanzId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAmbulanzRequestToJSON(requestParameters['updateAmbulanzRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AmbulanzResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateAmbulanz(requestParameters: UpdateAmbulanzOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmbulanzResponse> {
        const response = await this.updateAmbulanzRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
